// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"4e6d6983","404":"10cca746","498":"ba8e6477","787":"4242ccff"}[chunkId] + ".chunk.js";
};